import {
  trackPhoneClick,
  trackWhatsappClick,
  trackViberClick,
  trackSocialClick,
} from "./dataLayer";

function findAnchor(target) {
  let el = target;
  while (el && el !== document && el !== document.body) {
    if (el.tagName === "A" && el.href) return el;
    el = el.parentElement;
  }
  return null;
}

function classify(href) {
  const h = String(href || "").toLowerCase();
  if (h.startsWith("tel:")) return { type: "phone" };
  if (h.includes("wa.me") || h.includes("api.whatsapp.com") || h.includes("whatsapp.com/send")) {
    return { type: "whatsapp" };
  }
  if (h.startsWith("viber:")) return { type: "viber" };
  if (h.includes("facebook.com") || h.includes("fb.com") || h.includes("fb.me")) {
    return { type: "social", network: "facebook" };
  }
  if (h.includes("instagram.com")) {
    return { type: "social", network: "instagram" };
  }
  return null;
}

/**
 * One document-level listener for tel / WhatsApp / Viber / social.
 */
export function initOutboundClickTracking() {
  if (typeof window === "undefined" || window.__vlvOutboundClicksInit) return;
  window.__vlvOutboundClicksInit = true;

  document.addEventListener(
    "click",
    (e) => {
      const a = findAnchor(e.target);
      if (!a) return;
      const kind = classify(a.href);
      if (!kind) return;
      if (kind.type === "phone") trackPhoneClick();
      else if (kind.type === "whatsapp") trackWhatsappClick();
      else if (kind.type === "viber") trackViberClick();
      else if (kind.type === "social") trackSocialClick(kind.network);
    },
    true
  );
}
